@if (!isPredefinedView() || !symbol) {
  @if (symbol) {
    @if (symbol.type === 'emoji') {
      <rt-emoji [emoji]="symbol.unicode" [size]="14" />
    }
    @if (symbol.type === 'icon') {
      <rt-icon-font [name]="symbol.name" [size]="'small'" />
    }
  } @else if (layoutType) {
    <rt-icon [name]="LAYOUT_ICON_MAP[layoutType]" [size]="'small'" />
  }
} @else {
  @if (symbol && symbol.type === 'icon') {
    <rt-icon [name]="$any(symbol.name)" [size]="'small'" />
  }
  @if (symbol && symbol.type === 'emoji') {
    <rt-emoji [emoji]="symbol.unicode" [size]="14" />
  }
}
